import React, { Fragment, useCallback, useState } from "react";
import { GifList, IUserList } from "./GifList";
import { IGif, INicheMap } from "services/types";
import { ViewRegion } from "utils/metrics";
import { FilterByTag } from "components/UI/FilterByTag";
import { Loader } from "../UI/Loader";

interface IProps {
  userID: string;
  topic: string;
  order: string;
  hasMore: boolean;
  totalLength: number;

  gifs: IGif[];
  users: IUserList;
  niches?: INicheMap;

  changeTopic: (topic: string) => void;
  changeOrder: (order: string) => void;
  fetchMore: () => void;

  changeTags: (name: string) => void;
  selectedTags: string[];

  isError?: boolean;
  isLoading?: boolean;
}

export const ProfileGifList = (
  {
    userID,
    topic,
    order,
    hasMore,
    totalLength,
    gifs,
    users,
    niches,
    changeTopic,
    changeOrder,
    fetchMore,
    isError,
    isLoading,
    changeTags,
    selectedTags
  }: IProps) => {

  const [tiles, setTiles] = useState<boolean>(true);
  const [isLoadingTags, setIsLoadingTags] = useState<boolean>(true);

  const changeMode = useCallback((mode: boolean) => {
    console.debug(`[ProfileGifList] tiles changed to ${mode}`);
    setTiles(mode);
  }, []);

  const handleTagsLoaded = useCallback(() => {
    setIsLoadingTags(false);
  }, []);

  return (
    <Fragment>
      <FilterByTag
        userId={userID}
        changeTags={changeTags}
        selectedTags={selectedTags}
        topic={topic}
        onLoaded={handleTagsLoaded}
      />

      { (!isLoading || totalLength > 0) && !isLoadingTags && (
        <GifList
          className="userGifList"
          ordering
          topic={topic}
          order={order}
          tiles={tiles}
          gifs={gifs}
          users={users}
          niches={niches}
          userID={userID}
          totalLength={totalLength}
          hasMore={hasMore}
          changeTopic={changeTopic}
          changeOrder={changeOrder}
          changeMode={changeMode}
          fetchMore={fetchMore}
          isError={isError}
          isLoading={isLoading}
          source={ViewRegion.Profile}
          sourceId={null}
          rel={`user:${userID}`}
          isVerifyHidden
          showPinnedGifs
        />
      )}

      { isLoading && (
        <Loader />
      )}
    </Fragment>
  );
};
